<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Sell "></springText>
      <springText class="item-title" text="Character NFTs"></springText>
    </div>
    <fadeInAnimation>
      <div class="text-list">
        <div class="text-item">
          <div class="title">
            Withdraw Character NFTs to Your Wallet
          </div>
          <div class="sub-title">
            Go to third-party marketplaces like OpenSea, OKX, etc., to sell your character NFTs.
          </div>
          <div class="sub-title alink-sub">
            <div class="icon-wrap">
              <img src="@/assets/images/playDetails/marketplace/tradingLink.png" alt="">
            </div>
            Trading Link: <a target="_blank"
              href="https://www.okx.com/web3/marketplace/nft/collection/polygon/matr1x-fire-character">https://www.okx.com/web3/marketplace/nft/collection/polygon/matr1x-fire-character</a>
            <i class="el-icon-caret-right"></i>
          </div>
        </div>
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>